import { minBy, sortBy, identity } from "lodash"

/**
 * top n
 */

// #TODO make if work with any kind of collection
// #TODO optimize this shit
// #TODO test this shit

export function topBy(n, a, by = identity) {
  let threshold = -Infinity
  const result = []

  a.forEach(x => {
    const y = by(x)

    if (result.length < n) {
      result.push(x)
      threshold = by(minBy(result, by))
    }
    else if (y > threshold) {
      const looserIndex = result.findIndex(ri => by(ri) == threshold)
      result[looserIndex] = x
      threshold = by(minBy(result, by))
    }
  })

  return sortBy(result, ri => -by(ri))
}

export function top(n, a) {
  return topBy(n, a, identity)
}




// WEBPACK FOOTER //
// ./src/lib/tools/topBy.js